import React, { useMemo, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const token = useMemo(() => searchParams.get("token") || "", [searchParams]);

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [status, setStatus] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("");
        setError("");

        if (!token) {
            setError("Reset token is missing.");
            return;
        }

        if (password.length < 8) {
            setError("Password must be at least 8 characters long.");
            return;
        }

        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        setSubmitting(true);

        try {
            const res = await fetch("/api/auth/reset-password", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ token, password }),
            });

            const data = await res.json();

            if (!res.ok) {
                setError(data.message || "Failed to reset password.");
                setSubmitting(false);
                return;
            }

            setStatus(data.message || "Password reset successfully.");

            setTimeout(() => {
                navigate("/login");
            }, 1500);
        } catch (err) {
            console.error("Reset password error:", err);
            setError("Server error.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "grid",
                placeItems: "center",
                background: "var(--background, #f7f7fb)",
                padding: 24,
            }}
        >
            <div
                style={{
                    width: "100%",
                    maxWidth: 460,
                    background: "var(--card-bg, #fff)",
                    border: "1px solid var(--border, #e5e7eb)",
                    borderRadius: 20,
                    padding: 28,
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                }}
            >
                <h1 style={{ margin: "0 0 10px", fontSize: "1.6rem" }}>
                    Reset Password
                </h1>

                <p style={{ margin: "0 0 20px", color: "var(--muted, #666)" }}>
                    Enter your new password below.
                </p>

                <form onSubmit={handleSubmit} style={{ display: "grid", gap: 14 }}>
                    <label style={{ display: "grid", gap: 8 }}>
                        <span>New Password</span>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter new password"
                            style={{
                                padding: "12px 14px",
                                borderRadius: 12,
                                border: "1px solid var(--border, #d1d5db)",
                                outline: "none",
                            }}
                        />
                    </label>

                    <label style={{ display: "grid", gap: 8 }}>
                        <span>Confirm Password</span>
                        <input
                            type="password"
                            required
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm new password"
                            style={{
                                padding: "12px 14px",
                                borderRadius: 12,
                                border: "1px solid var(--border, #d1d5db)",
                                outline: "none",
                            }}
                        />
                    </label>

                    <button
                        type="submit"
                        disabled={submitting}
                        style={{
                            padding: "12px 16px",
                            borderRadius: 12,
                            border: "none",
                            cursor: submitting ? "not-allowed" : "pointer",
                            background: "var(--accent-color, #5A3EBA)",
                            color: "#fff",
                            fontWeight: 700,
                            opacity: submitting ? 0.7 : 1,
                        }}
                    >
                        {submitting ? "Saving..." : "Reset Password"}
                    </button>
                </form>

                {status ? (
                    <p style={{ marginTop: 16, color: "green" }}>{status}</p>
                ) : null}

                {error ? (
                    <p style={{ marginTop: 16, color: "crimson" }}>{error}</p>
                ) : null}

                <div style={{ marginTop: 20 }}>
                    <Link to="/login">Back to Login</Link>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;